import React, { useEffect, useRef, useState } from 'react';
import searchIconIMG from "../../assets/images/megnificant-glass.png";
import Location from "../../components/Map/Location";
import AddDevice from "../../components/AddDevice/AddDevice";
import CommonTable from "../../components/Table/CommonTable";
import { useContextValue } from '../../context/LoaderContext';
import ExternalShareurl from '../../components/ExternalCard/ExternalShareurl';
import DeviceControlBar from '../../components/DeviceControlBar/DeviceControlBar';
import { DEVICE, MONTHS, SMS_COMMANDS } from '../../utils/const';
import useApi from '../../hook/useAPI';
import Timer from '../../components/Timer/timer';
import "./Trips.scss";
import { get } from 'lodash';
import { convert } from '../../utils/moment';
import { findDeviceInList, mergeDeviceRagFields } from '../../utils/deviceRagDisplay';

function Trips() {
  const { getData, postData, loading } = useApi();
  const { setDevice, device } = useContextValue();
  const [isOpen, setIsOpen] = useState(false)
  const [deviceDetails, setDeviceDetails] = useState()
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [tripDetail, setTripDetail] = useState([]);
  const [allTripDetail, setAllTripDetail] = useState([]);
  const [sortBy, setSortBy] = useState("");
  const [sortType, setSortType] = useState("");
  const [searchTerm, setSearchTerm] = useState('');
  const [center, setCenter] = useState({ lat: 33.5779, lng: -101.8552 });
  // const deviceStoredData = JSON.parse(localStorage.getItem('deviceData')) || null;
  const deviceStoredData = null;
  const [data, setData] = useState([]);
  const [devicesList, setDevicesList] = useState([]);
  const [deviceLocations, setDeviceLocations] = useState([]);
  const [deviceLocationsForMap, setDeviceLocationsForMap] = useState([]);
  const [currentTripDetails, setCurrentTripDetails] = useState(null);
  const [timerData, setTimerData] = useState(null);
  const [currentRecentTrip, setCurrentRecentTrip] = useState(null);
  const mapRef = useRef(null);
  const [currentMode, setCurrentMode] = useState(SMS_COMMANDS.RECOVER_MODE_30);


  const columnsOptions = [
    { header: "Device Name", key: 'device' },
    { header: "Start Location", key: 'startlocation', },
    { header: "End Location", key: 'endlocation', },
    { header: "Duration", key: 'duration', },
    { header: "Distance Traveled", key: 'distance', },
    { header: "Date / Time", key: 'date' }
  ]
  const rowData = [
    {
      device: "LocShark Tablet #1",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #2",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #3",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #4",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
    {
      device: "LocShark Tablet #5",
      startlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      endlocation: 'Alsfeld Ranch, Braunridge, San Antonio, Bexar County, Texas, United States',
      duration: '1 Hour',
      distance: '50 miles',
      date: '25 Apr 2024 18:01:38'
    },
  ];

  const fetchTripDetails = async (searchText) => {
    try {
      const url = searchText ? `${DEVICE.GET_DEVICE_TRIP}?search=${searchText}` : `${DEVICE.GET_DEVICE_TRIP}?page=${currentPage}&limit=${itemsPerPage}&search=${searchTerm}`
      const response = await getData(url,);
      if (response?.status || response.status === 200) {
        setTotalPages(response.totalPages || 1);
        setCurrentPage(Number(response.currentPage) || 1);
        // setTripDetail(response?.data)
        const getAddress = (latitude, longitude) => {
          return new Promise((resolve, reject) => {
            if (latitude && longitude && window?.google) {
              const geocoder = new window.google.maps.Geocoder();
              const location = { lat: parseFloat(latitude), lng: parseFloat(longitude) };

              geocoder.geocode({ location }, (results, status) => {
                if (status === "OK" && results[0]) {
                  resolve(results[0].formatted_address);  // Return the formatted address
                } else {
                  console.error("Geocoder failed due to: " + status);
                  resolve("-");  // Return a default value in case of failure
                }
              });
            } else {
              resolve("-");
            }
          });
        };

        const tripList = response?.data?.map(async (data) => {
          const [trip] = data?.trips;
          const end_time = new Date(trip.end_time).getTime();
          const start_time = new Date(trip.final_adjust_ime).getTime();

          // console.log("trip",trip.final_adjust_ime,trip.end_time,trip);
          const durationInMilliseconds = end_time - start_time;

          // console.log("durationInMilliseconds",durationInMilliseconds,trip.distance,end_time,start_time,trip.end_time,trip.final_adjust_ime);

          const totalSeconds = Math.floor(durationInMilliseconds / 1000);
          const hours = Math.floor(totalSeconds / 3600);
          const minutes = Math.floor((totalSeconds % 3600) / 60);
          const seconds = totalSeconds % 60;

          let formattedDuration = "";

          if (hours > 0) {
            formattedDuration += `${hours} hr `;
          }
          if (minutes > 0 || hours > 0) {
            formattedDuration += `${minutes} min `;
          }
          if (seconds > 0 || (!hours && !minutes)) {
            formattedDuration += `${seconds} sec`;
          }

          formattedDuration = formattedDuration.trim()

          const endTime = new Date(trip.dateTime);
          const formattedDate = convert(endTime, "DD MMM YYYY HH:mm:ss");


          return {
            start_coordinate: trip.start_coordinate,
            end_coordinate: trip.end_coordinate,
            device: trip.deviceName,
            startlocation: trip.start_address,
            endlocation: trip.end_address,
            duration: formattedDuration,
            distance: trip.distance + ' Miles',
            date: formattedDate
          }

        });

        Promise.all(tripList).then((tripList) => {
          setAllTripDetail(tripList);
        }).catch((error) => {
          console.error("Error processing trips:", error);
        });
      }



    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };


  useEffect(() => {
    fetchTripDetails();
  }, [itemsPerPage, currentPage, searchTerm])

  useEffect(() => {
    fetchLocations()
  }, [])

  const openDeviceDetail = (item) => {
    setSearchTerm(item.name)
    setIsOpen(true)
    setDevice(item.name)
    const locationRow = findDeviceInList(item, devicesList);
    setDeviceDetails(mergeDeviceRagFields(item, locationRow))
    getDevice();
    getCurrentTrip(item);
    setLocationForMap(item._id);
    setCurrentRecentTrip(null);
    if (window.innerWidth < 575) {
      scrollToTop()
    }

  }

  const getDevice = async () => {
    try {
      const response = await getData(`${DEVICE?.GET_DEVICE_LOCATIONS_v2}/?page=${1}&limit=${100}`);
      if (response.status == 200 && response?.data.length > 0) {
        setDevicesList(response?.data);
      } else {
        console.log('Failed to fetch device details.');
      }
    } catch (err) {
      console.error("Error fetching device details:", err);
    }
  }

  useEffect(() => {
    if (!isOpen) {
      setDevice("")
      // setDeviceDetails(deviceStoredData[0])
    }
  }, [isOpen])
  useEffect(() => {
    if (deviceDetails?._id) {
      fetchDeviceTripDetails();
    }
  }, [deviceDetails?._id])

  useEffect(() => {
    if (device === "") {
      setIsOpen(false);

    }
  }, [device])

  useEffect(() => {
    if (isOpen === false) {
      setLocationForMap();
      setCurrentRecentTrip(null);
    }
  }, [isOpen])
  const GetCurrentTripStatus = async () => {
    // const token = localStorage.getItem('TokenDevice')
    // try {
    //   if(token){

    //     const response = await postDataDevice(DEVICE.GET_CURRENT_DEVICE_STATUS, ClientId,token);
    //     if (response?.Data.length > 0) {
    //       setDeviceData(response?.Data)
    //     }
    //   }
    // } catch (error) {
    //   console.error("Error fetching device details:", error);
    // }
  };
  useEffect(() => {
    GetCurrentTripStatus()
  }, [])
  const handleItemsPerPageChange = (event) => {
    setItemsPerPage(Number(event.target.value));
    // setCurrentPage(1);
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const fetchDeviceTripDetails = async () => {
    try {
      const response = await getData(`${DEVICE.GET_DEVICE_TRIP}?deviceId=${deviceDetails?._id}`,);

      if (response.status || response.status === 200) {


        let result = null;

        for (let i = 0; i < response?.data.length; i++) {
          const trips = response?.data[i].trips;

          if (trips.length > 0) {
            result = trips;
            break;
          }
        }
        setTripDetail(result);
      }

    } catch (error) {
      console.error("Error fetching user details:", error);
    }
  };

  const setTimerDataLocally = (data) => {
    const td = {
      status: data.timer_status,
      start_time: data.start_time,
      adjust_start_time: data.final_adjust_ime,
      pause_time: data.pause_times,
      resume_time: data.resume_times,
    }
    setTimerData(td);
  }
  const getCurrentTrip = async (item = null) => {
    let deviceId = item !== null ? item._id : deviceDetails._id;
    const { result } = await getData(`${DEVICE.GET_DEVICE_TRIP}/v2/${deviceId}`);
    // console.log("result======================>>>>>>><<<<",result,deviceId);
    if (result != null) {
      setTimerDataLocally(result)
      setCurrentTripDetails(result)
    } else {
      setCurrentTripDetails(item);
      setTimerData(null);
    }

  }
  // Add sendRecoveryModeSMS function (copied from DeviceControlBar)
  const sendRecoveryModeSMS = async () => {
    if (!deviceDetails) return;
    const oncetoken = localStorage.getItem("1nce_access_token");
    let data = {
      simId: deviceDetails.simCardNumber,
      token: oncetoken,
      message: SMS_COMMANDS.RECOVER_MODE_3,
      device_id: deviceDetails?._id
    };
    let url = DEVICE.SEND_SMS;
    try {
      await postData(url, data);
      // Optionally, you can show a toast here if needed
    } catch (err) {
      // Optionally, handle error or show a toast
    }
  };
  // Add function to fetch and update current device status for the selected device
  const fetchAndUpdateDeviceStatus = async () => {
    if (!deviceDetails) return;
    try {
      const response = await getData(`${DEVICE.GET_DEVICE_STATUS}?search=${deviceDetails.name}`);
      if (response?.status === 200 && response?.data.length > 0) {
        // Find the device by ID in the response
        const updatedDevice = response.data.find(
          (d) => String(d.deviceId) === String(deviceDetails._id),
        );
        if (updatedDevice) {
          setDeviceDetails(mergeDeviceRagFields(deviceDetails, updatedDevice));
          // Set currentMode based on recovery_mode
          if (updatedDevice.recovery_mode === 'rc_3' || updatedDevice.recovery_mode === undefined) {
            setCurrentMode(SMS_COMMANDS.RECOVER_MODE_3);
          } else {
            setCurrentMode(SMS_COMMANDS.RECOVER_MODE_30);
          }
        }
      }
    } catch (error) {
      // Optionally handle error
    }
  };

  const startTimer = async (timer) => {
    // Trigger Recovery Mode API before starting the trip
    await sendRecoveryModeSMS();
    // Fetch and update the latest device status (including recovery_mode)
    await fetchAndUpdateDeviceStatus();
    // Set Recovery Mode UI to checked (RECOVER_MODE_3)
    setCurrentMode(SMS_COMMANDS.RECOVER_MODE_3);
    if (deviceDetails) {
      const trip = await postData(`${DEVICE.CREATE_TRIP}`, {
        start_time: timer,
        device_id: deviceDetails._id
      });
      setCurrentTripDetails(trip.result);
    }
  }

  const stopTimer = async (end_time) => {
    if (currentTripDetails) {
      await postData(`${DEVICE.END_TRIP}/${currentTripDetails.tripId}`, {
        end_time
      });
      fetchTripDetails();
    }
  }

  const resumeTimer = async (new_start_time, resume_time) => {
    if (currentTripDetails) {
      await postData(`${DEVICE.RESUME_TRIP}/${currentTripDetails.tripId}`, {
        resume_time,
        adjust_start_time: new_start_time
      });
    }
  }

  const pauseTimer = async (pause_time) => {
    if (currentTripDetails) {
      await postData(`${DEVICE.PAUSE_TRIP}/${currentTripDetails.tripId}`, {
        pause_time
      });
    }
  }

  const fetchLocations = async () => {
    try {
      const response = await getData(`${DEVICE?.GET_DEVICE_LOCATIONS_v2}/?page=${1}&limit=${10}`);
      if (response?.status == 200 && response?.data?.length > 0) {
        setDeviceLocations(response?.data)
        setLocationForMap(null, response?.data);

      } else {

        console.log('Failed to fetch device details.');
      }
    } catch (err) {

      console.error("Error fetching device details:", err);
    }
  }


  const setLocationForMap = (deviceId = null, data = null) => {
    let locations = (data) ? data : deviceLocations

    if (deviceId) {
      locations = locations.filter((data) => data?.deviceId == deviceId);
    }
    if (locations.length > 0) {
      setCenter({
        lat: Number(locations[0].latitude),
        lng: Number(locations[0].longitude)
      });
    }

    setDeviceLocationsForMap(locations);



  };

  useEffect(() => {
    if (currentRecentTrip) {
      scrollToTop();
    }
  }, [currentRecentTrip]);
  const scrollToTop = () => {
    if (mapRef.current) {
      const yOffset = -100; // Scroll to 100px *above* the element
      const y = mapRef.current.getBoundingClientRect().top + window.pageYOffset + yOffset;

      document.querySelector('.dashboard_main_content-max-padding').scrollTo({ top: y, behavior: 'smooth' });
    }
  }
  return (
    <>
      <div className="dashboard" ref={mapRef}>
        <div className="row">
          <div className="col-lg-7 col-xl-8"  >
            <div className="card map-height">
              <div className="card-body p-0" >
                <Location trip tripDetail={currentRecentTrip ? [currentRecentTrip] : []} DevicesList={currentRecentTrip == null ? deviceLocationsForMap : []} center={center} setCenter={setCenter} />
                {
                  currentRecentTrip == null ? (
                    <Timer btnText="Trip" show={isOpen} heading={(deviceDetails) ? deviceDetails.name : ''} startEvent={startTimer} stopEvent={stopTimer} resumeEvent={resumeTimer} pauseEvent={pauseTimer} timerData={timerData} />

                  ) : (
                    <div className="close-trip">
                      <button className="btn btn-primary" onClick={() => {
                        setCurrentRecentTrip(null);
                        if (deviceDetails) {
                          setLocationForMap(deviceDetails._id)
                        } else {
                          setLocationForMap();
                        }
                      }}>Close Trip</button>
                    </div>
                  )
                }



              </div>
            </div>
          </div>

          <div className="col-lg-5 col-xl-4 ">
            <div className="card new-background">
              <div className="card-body new-card-body">
                {isOpen ? (
                  <>
                    <ExternalShareurl tripDetail={tripDetail ? tripDetail : []} setSearchTerm={setSearchTerm} deviceDetails={deviceDetails} devicesList={devicesList} setTripDetail={setTripDetail} />
                    <DeviceControlBar deviceDetails={deviceDetails} devicesList={devicesList} setCenter={setCenter} currentMode={currentMode} setCurrentMode={setCurrentMode} />
                  </>
                ) : (
                  <div className="card">
                    <div className="card-body">
                      <AddDevice setData={setData} handleMenu={openDeviceDetail} AddDeviceData={GetCurrentTripStatus} />
                    </div>
                  </div>
                )}
                {/* <AddDevice handleMenu={openDeviceDetail} AddDeviceData={GetCurrentTripStatus} /> */}
              </div>
            </div>
          </div>
        </div>

        {/* common table card start  */}
        <div className="card">
          <div className="card-body p-0 ">
            <div className="home-table-chart-box">
              <div className="top_bar">
                <div className="card_title">Recent Trips</div>
                <div className="input-group">
                  <span className="input-group-text" id="basic-addon1">
                    <img
                      src={searchIconIMG}
                      className="ing-fluid"
                      alt="search-icon"
                    />
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search or type a command"
                    onChange={(e) => fetchTripDetails(e.target.value)}
                    aria-label="Username"
                    aria-describedby="basic-addon1"
                  />
                </div>
              </div>

              {/* <CommonTable columns={columnsOptions} rows={rowData} /> */}
              <CommonTable
                columns={columnsOptions}
                rows={allTripDetail}
                onTripSelect={setCurrentRecentTrip}
                itemsPerPage={itemsPerPage}
                totalPages={totalPages}
                currentPage={currentPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                onPageChange={handlePageChange}
                isPagination
                sortBy={sortBy}
                setSortBy={setSortBy}
                setSortType={setSortType}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Trips